import React from 'react';
import PropTypes from "prop-types";
import { TranslationContext } from '../checkout/config/Translations';

const DetailsToggle = ({
    lessToggle,
    moreToggle,
    toggleOn: propsToggleOn,
    onClick,
    index,
    ...rest
}) => {
    const [ toggleOn, setToggleOn ] = React.useState(true);
    const translate  = React.useContext(TranslationContext).t;
    const lessText = lessToggle ?? translate('checkout__less_details');
    const moreText = moreToggle ?? translate('checkout__more_details');
    const isToggleOn = propsToggleOn === undefined ? toggleOn : propsToggleOn;

    return (
        <button
            className="button button--link ticket-description__toggle"
            onClick={() => {
                setToggleOn(!toggleOn);
                onClick(index);
            }}
            {...rest}
        >
            {isToggleOn ? '+ ' + moreText : '- ' + lessText}
        </button>
    )
}

DetailsToggle.propTypes = {
    onClick: PropTypes.func.isRequired,
    lessToggle: PropTypes.string,
    moreToggle: PropTypes.string,
    toggleOn: PropTypes.bool,
};

export default DetailsToggle;
